import { render, staticRenderFns } from "./AuditBreakpointsForm.vue?vue&type=template&id=ccbf3142&scoped=true&"
import script from "./AuditBreakpointsForm.vue?vue&type=script&lang=js&"
export * from "./AuditBreakpointsForm.vue?vue&type=script&lang=js&"
import style0 from "./AuditBreakpointsForm.vue?vue&type=style&index=0&id=ccbf3142&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbf3142",
  null
  
)

export default component.exports